/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ReferenceListPropertyConfig } from "./ReferenceListPropertyConfig";
import { BaseProperty } from "./BaseProperty";
import { ArrayableProperty } from "./ArrayableProperty";
export const ReferenceListProperty = core.serialization
    .object({
    config: ReferenceListPropertyConfig,
})
    .extend(BaseProperty)
    .extend(ArrayableProperty);
